<template>
  <div data-v-6bd700be="" data-v-e5781868="" class="home main mainContent top50">
    <div id="redPacket"  v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow" >
      <i class="grab"  @click="$parent.goNav('/userredpacket')"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />

    </div>
    <div data-v-8ea00d66="" data-v-6bd700be="" class="announcements">
      <div data-v-8ea00d66="" class="content">
        <svg data-v-338e1447="" data-v-8ea00d66="" aria-hidden="true" class="svg-icon iconSpeaker">
          <use data-v-338e1447="" xlink:href="#icon-iconSpeaker"></use>
        </svg>
        <div data-v-8ea00d66="" class="message">
          <marquee data-v-8ea00d66="" direction="left" onmouseout="this.start();" onmouseover="this.stop();" class="left text">
            <a data-v-8ea00d66="" @click="$parent.goNav('/messages?type=1')" href="javascript:void(0);" v-for="(item, index) in homenoticelis" :key="index">{{ item }}</a>
          </marquee>
          <a data-v-8ea00d66="" class="btn" href="javascript:void(0);" @click="$parent.goNav('/messages?type=1')">更多</a>
        </div>
      </div>
    </div>
    <div data-v-57927282="" data-v-6bd700be="" class="homeBanner">
      <div data-v-57927282="" class="banner banner-unlogin" style="background:#fafafa;">
        <div data-v-57927282="" class="content">
          <div data-v-57927282="" class="bannerSwiper">
            <div data-v-57927282="" class="swiper-container swiper swiper-container-horizontal">
          
              <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
                <div data-v-57927282="" class="swiper-slide" style="width: 100%" v-for="(item, index) in bannerList" :key="index">
                  <div data-v-57927282="" class="imgOne">
                    <div data-v-57927282="" class="img"><img data-v-57927282="" :src="item.src" /></div>
                  </div>
                </div>
              </div>

              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <div data-v-57927282="" class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
              <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1"></span><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2"></span
              ><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3"></span>
            </div>
            <div data-v-57927282="" slot="button-prev" class="swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true">
              <svg data-v-338e1447="" data-v-57927282="" aria-hidden="true" class="svg-icon iconBannerPrev">
                <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
              </svg>
            </div>
            <div data-v-57927282="" slot="button-next" class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false">
              <svg data-v-338e1447="" data-v-57927282="" aria-hidden="true" class="svg-icon iconBannerNext">
                <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-6bd700be="" class="section section1" style="background:#fff;">
      <div data-v-6bd700be="" class="content">
        <div data-v-6bd700be="" class="group">
          <div data-v-6bd700be="" class="img">
            <img data-v-6bd700be="" src="/static/image/img1.png_.0b93c5c8.webp" />
            <div data-v-6bd700be="" class="ring"><span data-v-6bd700be="" class="ring1"></span><span data-v-6bd700be="" class="ring2"></span><span data-v-6bd700be="" class="ring3"></span></div>
          </div>
          <div data-v-6bd700be="" class="info">
            <div data-v-6bd700be="" class="title"></div>
            <p data-v-6bd700be="">单注最高200万 豪客首选</p>
            <p data-v-6bd700be="">多台下注 盈利翻倍</p>
            <div data-v-6bd700be="" class="value">
              <p data-v-6bd700be="">在线人数</p>
              <h1 data-v-6bd700be="">2224<span data-v-6bd700be="">人</span></h1>
            </div>
          </div>
          <div data-v-6bd700be="" class="buttons">
            <a data-v-6bd700be="" class="button button2">
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconAg">
                <use data-v-338e1447="" xlink:href="#icon-iconAg"></use>
              </svg>
              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" @click="$parent.openGamePage('ag', '1', '')" data-hover="立即进厅" class="text"><span data-v-6bd700be="">国际厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <a data-v-6bd700be="" class="button button1">
              <img src="/static/image/bg.png" class="svg-icon icon iconAg imgIcon" alt="" />
            

              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" @click="$parent.openGamePage('bg', 'videogame', '')" data-hover="立即进厅" class="text"><span data-v-6bd700be="">旗舰厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <a data-v-6bd700be="" class="button button3"
              ><svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconMore">
                <use data-v-338e1447="" xlink:href="#icon-iconMore"></use>
              </svg>
              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" class="text"><span data-v-6bd700be="" @click="$parent.goNav('/realPerson')">更多厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
          </div>
        </div>
        <div data-v-6bd700be="" class="row">
          <div data-v-6bd700be="" class="t">
            <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconServices">
              <use data-v-338e1447="" xlink:href="#icon-iconServices"></use>
            </svg>
            特色服务
          </div>
          <div data-v-6bd700be="" class="flexBox">
            <div data-v-6bd700be="" class="service">
              <img data-v-6bd700be="" src="/static/image/service1.png_.d54c8489.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">过夜利息</h2>
                <p data-v-6bd700be="">最高年利率36%，收益日结</p>
              </div>
            </div>
            <div data-v-6bd700be="" class="service">
              <img data-v-6bd700be="" src="/static/image/service2.png_.a9348920.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">股东日</h2>
                <p data-v-6bd700be="">每月8/18/28爽领分红、贷款</p>
              </div>
            </div>
            <div data-v-6bd700be="" class="service" @click="$parent.goNav('/details')">
              <img data-v-6bd700be="" src="/static/image/service3.png_.b1d69432.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">超级合伙人</h2>
                <p data-v-6bd700be="">三层抽佣模式 佣金拿到手抽筋</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-03c2c755="" data-v-6bd700be="" class="k8BrandWay">
      <div data-v-03c2c755="" class="content">
        <div data-v-03c2c755="" class="t">
          <svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconPromos">
            <use data-v-338e1447="" xlink:href="#icon-iconPromos"></use>
          </svg>
          品牌历程
        </div>
      </div>
      <div data-v-03c2c755="" class="c">
        <div data-v-03c2c755="" class="content">
          <div data-v-03c2c755="" class="timeline">
            <a data-v-03c2c755="" slot="button-prev" class="tool prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconPrev">
                <use data-v-338e1447="" xlink:href="#icon-iconPrev"></use></svg
            ></a>
            <div data-v-03c2c755="" class="swiper-container swiper swiper-container-initialized swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState" style="width: 20.43%"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item active">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2021</h3>
                          <p data-v-03c2c755="">09月16日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">07月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2020</h3>
                          <p data-v-03c2c755="">02月09日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2019</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2018</h3>
                          <p data-v-03c2c755="">10月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2017</h3>
                          <p data-v-03c2c755="">12月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">11月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">09月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">05月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">05月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2016</h3>
                          <p data-v-03c2c755="">12月25日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">07月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2015</h3>
                          <p data-v-03c2c755="">12月30日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2014</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2013</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <a data-v-03c2c755="" slot="button-next" class="tool next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconNext">
                <use data-v-338e1447="" xlink:href="#icon-iconNext"></use></svg
            ></a>
          </div>
          <div data-v-03c2c755="" class="box">
            <svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute1">
              <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute1"></use></svg
            ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute2">
              <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute2"></use>
            </svg>
            <div data-v-03c2c755="" class="swiper-img swiper-no-swiping swiper-container-horizontal" style="cursor: grab">
              <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购乐橙娱乐</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}正式收购乐橙娱乐，强强联手 携手共赢 实力见证</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" src="/static/image/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约两位巨星球员</h3>
                      <p data-v-03c2c755="">卢卡斯•波多尔斯基及韦斯利•斯内德正式成为{{$store.state.appInfo.title}}品牌代言人，实力升级，信誉保障</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" src="/static/image/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约意甲卡利亚里足球俱乐部</h3>
                      <p data-v-03c2c755="">卡利亚里足球俱乐部正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" src="/static/image/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购暴风竞技</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式收购暴风竞技，为业界全方位多元化布局打下坚实基础</p>
                    </div>
                    <div data-v-03c2c755="" class="promo"><img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" src="/static/image/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" /></div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">梦想基金助力湖北 为武汉加油</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}梦想基金会捐赠人民币200万给韩红爱心慈善基金会，正能量满满，一起为武汉加油</p>
                    </div>
                    <div data-v-03c2c755="" class="promo"><img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" src="/static/image/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" /></div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}捐赠物资对抗菲律宾百火山</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐爱心传递 公益先行 为社会救助送暖</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" src="/static/image/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">德甲劲旅沙尔克04给您拜年了</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐合作伙伴 德甲劲旅沙尔克04祝您新年快乐 财源广进</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" src="/static/image/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2019年度传记</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐2019年年度报告，邀您一同见证{{$store.state.appInfo.title}}年度巅峰事迹</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" src="/static/image/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助陈小春巡回演唱会</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐携手龙门联合赞助陈小春STOP ANGRY演唱会</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" src="/static/image/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐LOGO全新上线</h3>
                      <p data-v-03c2c755="">全新形象升级上线 新LOGO新气象 崭新面貌重新出发</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" src="/static/image/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约菲律宾及马尔代夫国家队</h3>
                      <p data-v-03c2c755="">菲律宾及马尔代夫国家队正式成为{{$store.state.appInfo.title}}娱乐的官方合作伙伴</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" src="/static/image/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐助力官方合作伙伴沙尔克04</h3>
                      <p data-v-03c2c755="">恭喜沙尔克04足球俱乐部在2019-2020新赛季再创佳绩</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" src="/static/image/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">AG平台首家开设200万限红</h3>
                      <p data-v-03c2c755="">业界首创 提供您至尊体验 豪客首选不容错过</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" src="/static/image/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2018年度传记</h3>
                      <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2018精采纪事 我们持续陪伴 为您生活增添更多精采</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" src="/static/image/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐收购悦博体育</h3>
                      <p data-v-03c2c755="">2018行业先锋 携手新老成员一起向前行</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" src="/static/image/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式推出USDT数字币</h3>
                      <p data-v-03c2c755="">最稳定最保值的货币，资金永不冻结 不受银行监管，安全又方便</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-169bc91c7ec4b0e7d3efeb1e2f3dfa0ab7.png_.webp" src="/static/image/banner-brand-169bc91c7ec4b0e7d3efeb1e2f3dfa0ab7.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约明星球员Henry（亨利）</h3>
                      <p data-v-03c2c755="">法国史上进球最多的球员-亨利正式成为{{$store.state.appInfo.title}}娱乐品牌代言人</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-179189eb61e2d492048f3d12ff9baa2e3f.png_.webp" src="/static/image/banner-brand-179189eb61e2d492048f3d12ff9baa2e3f.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助周杰伦地表最强2世界巡回演唱会</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐冠名赞助，邀请百位会员一同感受周董的现场魅力</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-18065fc6253e8381fc31897cfa92b6c0e0.png_.webp" src="/static/image/banner-brand-18065fc6253e8381fc31897cfa92b6c0e0.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2017年度传记</h3>
                      <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2017精采纪事 携手共同成长 打造更坚实的游戏平台</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-199b38df47a9ae1d94f670e0d6a2ca1f37.png_.webp" src="/static/image/banner-brand-199b38df47a9ae1d94f670e0d6a2ca1f37.png_.webp" />
                    </div>
                  </div>
                </div>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-9a4a8610="" data-v-6bd700be="" style="display: none">
      <div data-v-9a4a8610="" class="usdtBackdrop" style="display: none">
        <div data-v-9a4a8610="" class="popUSDT" style="display: none">
          <div data-v-9a4a8610="" class="topSect">温馨提示 <a data-v-9a4a8610="" class="close"></a></div>
          <div data-v-9a4a8610="" class="midSect">
            <div data-v-9a4a8610="" class="text">USDT账户已与人民币账户结合，详情如下</div>
            <div data-v-9a4a8610="" class="text"><b data-v-9a4a8610="">USDT额度：0</b><b data-v-9a4a8610="">兑换额度：0</b></div>
            <div data-v-9a4a8610="" class="btnCon"><a data-v-9a4a8610="" class="btn">立即兑换</a><a data-v-9a4a8610="" class="btn">查看余额</a></div>
            <div data-v-9a4a8610="" class="text2">*汇率将会实时更新实际以到账金额为主</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return { homenoticelis: [], bannerList: [] ,hongbashow:true,
      tanshow: true,
    
    };
  },
  created() {
    let that = this;
    that.homenotice(); 
    that.getBanList(); 
  },
  methods: {
            changtanshow() {
      this.tanshow = !this.tanshow;
    },
            changhongbashow() {
      this.hongbashow = false;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;

    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
:root {
  --bg-color: #ffffff !important;
  --text-color: #333333 !important;
  --border-color: #e0e0e0 !important;
  --card-bg: #ffffff !important;
  --hover-color: #f5f5f5 !important;
}

// 重置所有主要容器背景为白色
.home.main {
  background-color: var(--bg-color) !important;
  color: var(--text-color);
}

// 公告栏样式
.announcements {
  background-color: #f9f9f9;
  width: 80%;
  text-align: center;
  margin: 0 auto;
  box-shadow: inset 0 0 100px 1px #e0e0e0;
  border-radius: 10px;
  
  .content {
    color: var(--text-color);
    
    .message {
      .text a {
        color: var(--text-color);
      }
      
      .btn {
        color: var(--text-color);
      }
    }
  }
}

// 轮播图容器
.homeBanner {
  background-color: var(--bg-color);
  
  .banner {
    background-color: var(--bg-color);
    
    .content {
      background-color: var(--bg-color);
    }
  }
}

// 主要内容区域
.section.section1 {
  background-color: var(--bg-color);
  
  .content {
    background-color: var(--bg-color);
    
    .group {
      background-color: var(--card-bg);
      border: 1px solid var(--border-color);
      border-radius: 8px;
      
      .info p {
        color: var(--text-color);
      }
      
      .value {
        color: var(--text-color);
        
        h1 {
          color: #e53935; // 保留金额红色
        }
      }
    }
    
    .row {
      background-color: var(--bg-color);
      
      .t {
        color: var(--text-color);
      }
      
      .flexBox {
        background-color: var(--bg-color);
        
        .col {
          background-color: var(--card-bg);
          border: 1px solid var(--border-color);
          border-radius: 8px;
          
          .t {
            color: var(--text-color);
            border-bottom: 1px solid var(--border-color);
          }
          
          .box {
            background-color: var(--card-bg);
            
            .table {
              background-color: var(--card-bg);
              
              table {
                color: var(--text-color);
                border-collapse: collapse;
                
                th, td {
                  border-bottom: 1px solid var(--border-color);
                }
                
                tr.active {
                  background-color: #f9f9f9;
                }
              }
            }
            
            .profit {
              background-color: var(--card-bg);
              border: 1px solid var(--border-color);
              
              .user-name, h3, .amount, .records {
                color: var(--text-color);
              }
              
              .buttonBordered {
                background-color: transparent;
                color: #e53935;
                border: 1px solid #e53935;
              }
            }
          }
        }
      }
      
      .flexBox.service {
        .service {
          background-color: var(--card-bg);
          border: 1px solid var(--border-color);
          border-radius: 8px;
          
          .info {
            h2, p {
              color: var(--text-color);
            }
          }
        }
      }
    }
  }
}

// 品牌历程区域
.k8BrandWay {
  background-color: var(--bg-color);
  
  .content {
    background-color: var(--bg-color);
    
    .t {
      color: var(--text-color);
    }
  }
  
  .c {
    background-color: var(--bg-color);
    
    .content {
      background-color: var(--bg-color);
      
      .timeline {
        background-color: var(--card-bg);
        border: 1px solid var(--border-color);
        border-radius: 8px;
        
        .tool {
          color: var(--text-color);
        }
        
        .swiper-content {
          .line {
            background-color: #f0f0f0;
            
            .activeState {
              background-color: #e53935;
            }
          }
          
          .items {
            .item {
              color: var(--text-color);
              
              &.active {
                color: #e53935;
              }
              
              .bullet {
                border: 1px solid var(--border-color);
                background-color: var(--card-bg);
                
                &:before {
                  background-color: var(--border-color);
                }
              }
            }
          }
        }
      }
      
      .box {
        background-color: var(--card-bg);
        border: 1px solid var(--border-color);
        border-radius: 8px;
        
        .contentWraper {
          .info {
            h3, p {
              color: var(--text-color);
            }
            
            .link {
              color: #e53935;
            }
          }
        }
      }
    }
  }
}

// 按钮样式
.button {
  background-color: #f9f9f9;
  color: var(--text-color);
  border: 1px solid var(--border-color);
  
  &:hover {
    background-color: var(--hover-color);
  }
  
  &.button1 {
    background-color: #e53935;
    color: white;
    border-color: #e53935;
  }
  
  &.button2 {
    background-color: #4caf50;
    color: white;
    border-color: #4caf50;
  }
}

// 弹窗样式
.mask.register {
  background-color: rgba(0, 0, 0, 0.5);
  
  .panel {
    background-color: var(--card-bg);
    border: 1px solid var(--border-color);
    
    .group {
      color: var(--text-color);
      
      .note {
        color: #757575;
      }
    }
    
    .register-right-panel {
      background-color: #f9f9f9;
      
      .marquee {
        color: var(--text-color);
        
        .marquee-title {
          background-color: #e53935;
          color: white;
        }
      }
    }
  }
}

// 红包悬浮窗
#redPacket {
  border: 1px solid var(--border-color);
}

// 原有样式覆盖
.banner .bannerSwiper .swiper .swiper-slide .imgOne[data-v-57927282] {
  height: auto !important;
}
.banner .bannerSwiper[data-v-57927282] {
  height: auto !important;
}
.banner .bannerSwiper .swiper .swiper-slide[data-v-57927282] {
  height: auto !important;
}
.banner[data-v-57927282] {
  height: auto !important;
}
.imgIcon {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.1rem;
  vertical-align: middle;
  position: absolute;
  left: 0.5rem;
}
.banner .content[data-v-57927282] {
  padding-top: 0.2rem;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col3 .item {
  width: 100%;
  height: 1.22rem;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.08rem;
  margin-bottom: 0.05rem;
  padding: 0.1rem;
  position: relative;
  overflow: hidden;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col1 {
  padding: 0;
  width: 100%;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col1 .box .table {
  width: 8.4rem;
  height: 4.62rem;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.08rem;
  display: inline-block;
  margin-right: 0.16rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue